{
  "#RDP_LOG": {
    "APP": "RDP Log",
    "TITLE": "RDP Log",
    "OVERVIEW": "Übersicht",
    "SEARCH": "Suche",
    "OVERVIEW_PAGE": {
      "PAGE_TITLE": "RDP Logs",
      "FILTER_FROM": "Von:",
      "FILTER_TO": "Bis:",
      "FILTER_HEADING": "Angewendete Filter:",
      "LIST_HEADING_CONNECTION": "Verbindung",
      "LIST_HEADING_DETAILS": "Details",
      "LIST_HEADING_PROMPT": "Beschreibung",
      "LIST_HEADING_ACTIONS": "Aktionen",
      "MINUTE_ADDITION": "Aktionen",
      "DOWNLOAD": "Herunterladen",
      "TICKET": "Ticket"
    },
    "SEARCH_PAGE": {
      "PAGE_TITLE": "RDP Log Suche",
      "INPUT_FROM": "Von",
      "INPUT_TO": "Bis",
      "BTN_SEARCH": "Suche"
    },
    "MESSAGE": {
      "NO_DATA": "Es konnten keine Logs gefunden werden",
      "DOWNLOAD_ERROR": "Beim Download ist ein Fehler aufgetreten",
      "DOWNLOAD_SUCCESS": "Der Download war erfolgreich",
      "ERNEUT_VERSUCHEN": "Erneut versuchen"
    }
  }
}
